import { useQuery } from "@tanstack/react-query";

import type { Entitlement, WalletLedgerLine } from "../types/api";

export const entitlementsQueryKey = ["entitlements"] as const;
export const walletLedgerQueryKey = ["walletLedger"] as const;

export function hasGameEntitlement(
  entitlements: Entitlement[] | undefined,
  slug: string
): boolean {
  if (!entitlements?.length) return false;
  return entitlements.some(
    (e) => e.kind === "game_mode" && e.resource_slug === slug
  );
}

export function hasPackEntitlement(
  entitlements: Entitlement[] | undefined,
  slug: string
): boolean {
  if (!entitlements?.length) return false;
  return entitlements.some(
    (e) => e.kind === "content_pack" && e.resource_slug === slug
  );
}

export function hasBundleEntitlement(
  entitlements: Entitlement[] | undefined,
  slug: string
): boolean {
  if (!entitlements?.length) return false;
  return entitlements.some(
    (e) => e.kind === "bundle" && e.resource_slug === slug
  );
}

/** Legacy catalog entitlements API removed — modes use credits on `POST …/start/`. */
export function useEntitlements() {
  const query = useQuery({
    queryKey: entitlementsQueryKey,
    queryFn: async (): Promise<Entitlement[]> => [],
    staleTime: Infinity,
    initialData: [],
  });

  return {
    ...query,
    hasGameEntitlement: (slug: string) =>
      hasGameEntitlement(query.data, slug),
    hasPackEntitlement: (slug: string) =>
      hasPackEntitlement(query.data, slug),
    hasBundleEntitlement: (slug: string) =>
      hasBundleEntitlement(query.data, slug),
  };
}

/** Legacy wallet ledger API removed — purchase page no longer lists ledger lines. */
export function useWalletLedger() {
  return useQuery({
    queryKey: walletLedgerQueryKey,
    queryFn: async (): Promise<WalletLedgerLine[]> => [],
    staleTime: Infinity,
    initialData: [],
  });
}
